import { Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'apcam-divider-with-content',
    templateUrl: './divider-with-content.component.html',
    styleUrls: ['./divider-with-content.component.scss'],
    imports: [MatDividerModule],
})
export class DividerWithContentComponent {
    /**
     * Margin top [px] of the container
     *
     * Default: 0px
     */
    @Input()
    marginTop: number = 0;

    /**
     * Margin bottom [px] of the container
     *
     * Default: 0px
     */
    @Input()
    marginBottom: number = 0;
}
